import {Component, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {PrefixService} from '../../../../../services/frefix.service';
import { CreateStandardHeadComponent } from '../../create-standard.component';

@Component({
  selector: 'app-edit-standard-number',
  templateUrl: './edit-standard-number.component.html',
  styleUrls: ['./edit-standard-number.component.css'],
  providers: [CreateStandardHeadComponent]
})
export class EditStandardNumberComponentHead implements OnInit {

  stnNumber: string;
  public newNumber: string;

  constructor(public activeModal: NgbActiveModal,
              private prefixService: PrefixService ) {
  }

  ngOnInit() {
  }

  setCurrentNumber(number) {
    this.stnNumber = number;
    this.newNumber = number;
  }

  editNumber() {
    this.prefixService.customStndNumber = this.prefixService.getSelectedPrefix().name + this.newNumber;
    this.stnNumber = this.newNumber;
    this.activeModal.close('Close click');
  }

}



// WEBPACK FOOTER //
// C:/work/new2/internal-frontend/src/app/content-page/admin/create-standard-head/modal/edit-standard-number/edit-standard-number.component.ts